import { REACT_APP_SESSION_DATA } from "../../constants";
import { createContext, Dispatch } from "react";

export interface IUserDataProps {
    _id: string;
    username: string;
    name: string;
    country: string;
    position: string;
    deleted: boolean;
    title: string;
    verified: boolean;
    affiliation: string;
    createdAt: string;
    updatedAt: string;
    role?: string;
}

export interface IInitialStateProps {
    isLoading: boolean;
    isSignout: boolean;
    userToken?: string | null;
    userData?: IUserDataProps | null;
}

export const initialState: IInitialStateProps = {
    isLoading: true,
    isSignout: false,
    userToken: null,
    userData: null,
};

export type AuthAction = {
    token?: string | null;
    data?: IUserDataProps | null;
    type: "RESTORE_TOKEN" | "SIGN_IN" | "SIGN_UP" | "SIGN_OUT";
};

export const AuthContext = createContext<{
    state: IInitialStateProps;
    dispatch: Dispatch<AuthAction>;
}>({
    state: initialState,
    dispatch: () => {
        throw new Error("dispatch function must be overridden");
    },
});

// Reducer implementation
export const AuthReducer = (
    state: IInitialStateProps,
    action: AuthAction
): IInitialStateProps => {
    switch (action.type) {
        case "RESTORE_TOKEN":
            return {
                ...state,
                isLoading: false,
                userToken: action.token,
                userData: action.data,
            };

        case "SIGN_IN":
            return {
                ...state,
                isSignout: false,
                userToken: action.token,
                userData: action.data,
            };

        case "SIGN_UP":
            return {
                ...state,
                isSignout: false,
                userToken: action.token,
                userData: action.data,
            };

        case "SIGN_OUT":
            localStorage.removeItem(REACT_APP_SESSION_DATA);
            localStorage.removeItem("_wits_account_data");
            document.cookie = `_wits_session-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
            document.cookie = `_wits_user-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;

            return {
                ...state,
                isSignout: true,
                userToken: null,
                userData: null,
            };

        default:
            return state;
    }
};
